(() => {
  if (customElements.get('showhome-app-showcase')) return;

  customElements.define('showhome-app-showcase', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-app-tab]')];
      this.panels = [...this.querySelectorAll('[data-app-panel]')];
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.onClick = (event) => {
        const tab = event.target.closest('[data-app-tab]');
        if (tab) this.activate(this.tabs.indexOf(tab));
        const screenLink = event.target.closest('[data-app-screen-link]');
        if (screenLink) {
          const index = this.tabs.findIndex((item) => item.dataset.appScreen === screenLink.dataset.appScreenLink);
          if (index < 0) return;
          this.activate(index);
          // Keep keyboard focus in the phone when its previous panel is hidden.
          const destination = this.panels[index].querySelector(`[data-app-screen-link="${screenLink.dataset.appScreenLink}"]`);
          (destination || this.panels[index]).focus({ preventScroll: true });
        }
      };
      this.onKeydown = (event) => {
        const current = this.tabs.indexOf(event.target.closest('[data-app-tab]'));
        if (current < 0) return;
        let next;
        switch (event.key) {
          case 'ArrowDown': case 'ArrowRight': next = (current + 1) % this.tabs.length; break;
          case 'ArrowUp': case 'ArrowLeft': next = (current - 1 + this.tabs.length) % this.tabs.length; break;
          case 'Home': next = 0; break;
          case 'End': next = this.tabs.length - 1; break;
          default: return;
        }
        event.preventDefault();
        this.activate(next);
        this.tabs[next].focus({ preventScroll: true });
      };
      this.onBlockSelect = (event) => {
        const tab = event.target.closest('[data-app-tab]') || event.target.querySelector('[data-app-tab]');
        if (tab) this.activate(this.tabs.indexOf(tab));
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      const selected = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.activate(selected < 0 ? 0 : selected);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    activate(index) {
      if (index < 0 || index >= this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        panel.classList.toggle('is-active', i === index);
      });
      const caption = this.querySelector('[data-app-caption]');
      if (caption) caption.textContent = this.tabs[index].querySelector('.sh-app__tab-text')?.textContent || '';
    }
  });
})();
